import { Pagination } from 'types'

export const CITIZEN_INITIAL_PAGINATION: Pagination = {
  page: 1,
  limit: 12,
  sort: {
    by: 'name',
    order: 'ASC',
  },
}
